import React from 'react';
import { Button } from 'reactstrap';
import ReactGA from 'react-ga';

const SearchResult = (props) => {
    
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }

    const openLink = (item) => {
        let itemUrl = formatAmazonUrl(item.itemURLs);
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let evtVal = item.itemPrice ? parseInt(item.itemPrice, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'Search Result',
            label: "amazon.zom",
            value: evtVal
        });

    }

    const addItem = (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.handler(props.item);
    }

    return (
        <div className="m-2 flex-apart bg-white p-3 hover-cursor search-result-item" onClick={() => openLink(props.item)}>
            <img src={props.item.itemPic} style={{width: "60px"}} className="mr-2" alt="" />
            <p>{props.item.itemName}<br/>{props.item.itemPrice}</p>
            <div className="ml-2">
                <Button className="btn-success" onClick={(e) => addItem(e)}>ADD</Button>
            </div>
        </div>);
}
export default SearchResult;